import { defineMessages } from "react-intl";

export const messages = defineMessages({
  title: {
    id: 'LlvS/C',
    defaultMessage: "Member rules",
    description: "kit detail, card title",
  },
  addRule: {
    id: 'IzHWgg',
    defaultMessage: "Add rule",
    description: "kit detail, button",
  },
  removeRule: {
    id: 'MVSIp8',
    defaultMessage: "Remove rule",
    description: "kit detail, button",
  },
  noRulesYet: {
    id: 'brB/DO',
    defaultMessage: "No rules yet. Add a rule to say which members can be picked together.",
    description: "kit detail, empty rules panel on a kit that already has members",
  },
  addMembersFirst: {
    id: '4spP0v',
    defaultMessage: "Add two members first, then say how they depend on each other.",
    description: "kit detail, empty rules panel on a kit with fewer than two members",
  },
  subject: {
    id: '49yqn4',
    defaultMessage: "When this member is chosen",
    description: "kit rule field",
  },
  kind: {
    id: 'zy7s02',
    defaultMessage: "Rule",
    description: "kit rule field",
  },
  targets: {
    id: '3PsrBd',
    defaultMessage: "Applies to these members of this kit",
    description: "kit rule field",
  },
  message: {
    id: '8aov6Q',
    defaultMessage: "What the shopper is told",
    description: "kit rule field",
  },
  requiresOneOf: {
    id: 'QGayEW',
    defaultMessage: "Requires one of",
    description: "kit rule kind",
  },
  excludes: {
    id: '/Nj+Pd',
    defaultMessage: "Excludes",
    description: "kit rule kind",
  },
});
